export default {"src":"/_next/static/media/Reddit_Icon.b5fb07a0.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};